import { slice } from './slice';

const { reducer } = slice;
export * from './thunks';
export * as emailSelectors from './selectors';

export default reducer;
